import './point-of-sale.module';
import './point-of-sale.config';

import './components';
